export default __webpack_public_path__ + "static/media/dashboard.79561005.svg";